import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'

import style from '../style'

export class Navbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onItemHover(title, e) {
    this.setState({
      ...this.state,
      [title]: {
        ...(this.state[title] || {}),
        hover: true
      }
    })
  }

  onItemHoverOut(title, e) {
    this.setState({
      ...this.state,
      [title]: {
        ...(this.state[title] || {}),
        hover: false
      }
    })
  }

  onCollapseClick(e) {
    e.preventDefault()

    this.setState({
      ...this.state,
      collapse: !this.state.collapse
    })
  }

  render() {
    return (
      <Container>
        <Row>
          <Col sm="auto">
            <Link to={`/`}>
              <img
                src="/images/dark-logo.svg"
                alt="logo"
                title="logo"
                className={css(style.navbar.logo)}
              />
            </Link>
          </Col>
          <Col className={`d-flex d-lg-none`} />
          <Col xs="auto" className={`d-flex d-lg-none align-items-center`}>
            <button
              className={css(style.navbar.collapseButton)}
              onClick={this.onCollapseClick.bind(this)}
            >
              <i className={`fa fa-bars`} />
            </button>
          </Col>
          <Col
            xs="12"
            lg="auto"
            className={`${
              this.state.collapse ? `d-block` : `d-none`
            } d-lg-block`}
          >
            <ul
              className={`d-flex flex-column flex-lg-row ${css(
                style.navbar.list
              )}`}
            >
              <RenderListItem
                title={`Home`}
                desc={`welcome`}
                path={`/`}
                state={this.state.home || {}}
              />
              <RenderListItem
                title={`Info`}
                desc={`how it works`}
                path={`/info`}
                state={this.state.info || {}}
                onMouseEnter={this.onItemHover.bind(this, 'info')}
                onMouseLeave={this.onItemHoverOut.bind(this, 'info')}
                dropdown={[
                  { title: `about`, path: `/about` },
                  { title: `payments`, path: `/payments` },
                  { title: `privacy policy`, path: `/privacy` },
                  { title: `terms of service`, path: `/terms` },
                  { title: `games`, path: `/games` }
                ]}
              />
              <RenderListItem
                title={`partners`}
                desc={`join us`}
                path={`/partners`}
                state={this.state.partners || {}}
              />
              <RenderListItem
                title={`advertisers`}
                desc={`check us out`}
                path={`/advertisers`}
                state={this.state.advertisers || {}}
              />
              <RenderListItem
                title={`Contact`}
                desc={`write us`}
                path={`/contact`}
                state={this.state.contact || {}}
              />
              <RenderListItem
                title={`Story`}
                desc={`industry news`}
                href={`https://story.vppgamingnetwork.com`}
                state={this.state.story || {}}
              />
              {!this.props.token.accessToken ? null : (
                <RenderListItem
                  title={`Dashboard`}
                  desc={`manage it`}
                  path={`/dashboard`}
                  state={this.state.dashboard || {}}
                />
              )}
            </ul>
          </Col>
        </Row>
      </Container>
    )
  }
}

const RenderListItem = props => {
  if (props.href) {
    return (
      <li
        className={css(style.navbar.listItem)}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
      >
        <a
          href={props.href}
          className={`d-flex flex-column ${css(style.navbar.listItemLink)}`}
        >
          <span className={css(style.navbar.listItemTitle)}>{props.title}</span>
          <span
            className={`d-none d-lg-block ${css(style.navbar.listItemDesc)}`}
          >
            {props.desc}
          </span>
        </a>
        <RenderDropdown list={props.dropdown} active={props.state.hover} />
      </li>
    )
  }

  return (
    <li
      className={css(style.navbar.listItem)}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      <Link
        to={props.path}
        className={`d-flex flex-column ${css(style.navbar.listItemLink)}`}
      >
        <span className={css(style.navbar.listItemTitle)}>{props.title}</span>
        <span className={`d-none d-lg-block ${css(style.navbar.listItemDesc)}`}>
          {props.desc}
        </span>
      </Link>
      <RenderDropdown list={props.dropdown} active={props.state.hover} />
    </li>
  )
}

const RenderDropdown = props => {
  if (!props.list || !props.active) {
    return null
  }

  return (
    <ul className={css(style.navbar.dropdownList)}>
      {props.list.map((item, key) => (
        <li key={key}>
          <Link
            to={item.path}
            className={`d-block ${css(style.navbar.dropdownlistItemLink)}`}
          >
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/partials/Header/partials/navbar.js